import axios from "axios";

const isBrowser = typeof window !== "undefined";

// Use relative URL in browser to avoid CORS issues (works with www and non-www)
// Use full URL only for server-side requests
const getBaseURL = () => {
  if (isBrowser) {
    // In browser, use relative URL - this automatically uses the same origin
    return "/api";
  }
  // Server-side: use full URL
  if (process.env.NODE_ENV === "production") {
    return "https://conces.org/api";
  }
  return "http://localhost:3000/api";
};

const baseURL = getBaseURL();

const token = isBrowser ? localStorage.getItem("token") : null;

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  },
});

export default api;
